// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3qS8q","containerItemsCenter":"Skeleton_containerItemsCenter__3Sskc"};